/** @format */

import { createSlice } from '@reduxjs/toolkit'
import { request } from 'src/utils'
import _ from 'lodash'
import Api from 'src/api/ApiCommon'
import { localProductMenuData } from 'src/hooks/productMenuData'
export type GlobalDataKey =
  | 'productList'
  | 'monitorRegionList'
  | 'subProductList'
  | 'productMenu'
  | 'productSubMenu'

const API: Record<GlobalDataKey, string> = {
  productList: '/monitorapi/common/getProductList',
  monitorRegionList: '/monitor/?Action=DescribeMonitorRegions&Version=2021-01-01',
  subProductList: '/monitor/?Action=DescribeMonitorProductList&Version=2021-01-01',
  productMenu: Api.getProductMenu,
  productSubMenu: Api.getProductMenu
}

interface StartTimeType {
  startTime?: number
}

// 产品类型
export interface ProductStateType extends StartTimeType {
  list: {
    productName: string
    productType: number
    namespace: string
    costOptFlag?: number
    iamProjectFlag?: number
  }[]
}

// 监控机房列表
export interface RegionStateType extends StartTimeType {
  list: {
    regionId: number
    regionKey: string
    regionName: string
  }[]
}

// 云服务类别菜单
export interface ProductMenu extends StartTimeType {
  list: {
    title: string
    productType: number
    link: string
    namespance: string
    subMenus: ProductMenu[] | []
  }[]
}
//
interface GlobalDataType {
  productList: ProductStateType
  monitorRegionList: RegionStateType
  subProductList: ProductStateType
  productMenu: ProductMenu
  productSubMenu: ProductMenu
}

// 初始化数据
const initialState: GlobalDataType = {
  productList: { startTime: 0, list: [] },
  monitorRegionList: { startTime: 0, list: [] },
  subProductList: { startTime: 0, list: [] },
  productMenu: { startTime: 0, list: [] },
  productSubMenu: { startTime: 0, list: [] }
}

export const globalDataSlice = createSlice({
  name: 'globalData',
  initialState,
  reducers: {
    setProductList(state, { payload }) {
      const { dataType, list, startTime } = payload
      state[dataType].list = list
      state[dataType].startTime = startTime
    }
  }
})

const { setProductList } = globalDataSlice.actions

export const asyncGetProductList = dataType => {
  return asyncDispatch => {
    request(API[dataType], {}).then(({ data }) => {
      const payload = {
        dataType,
        startTime: new Date().valueOf()
      }
      if (dataType === 'subProductList') {
        _.set(payload, 'list', data?.productList || [])
      } else if (dataType === 'productList') {
        _.set(payload, 'list', data?.data[dataType] || [])
      } else if (dataType === 'productMenu') {
        const concat = data?.data.reduce((res, item) => res.concat(item?.subMenus || []), [])
        _.set(payload, 'list', concat || localProductMenuData)
      } else if (dataType === 'productSubMenu') {
        _.set(payload, 'list', data?.data)
      } else if (dataType === 'monitorRegionList') {
        _.set(payload, 'list', data?.data || [])
      }
      asyncDispatch(setProductList(payload))
    })
  }
}

export default globalDataSlice.reducer
